import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { Flag } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import { SecondaryTextButton } from '@bibliocommons/base-buttons';
import { FLAG_TYPES } from 'app/constants/FlagsConstants';

import './ContentWarnings.scss';

export default function ContentWarnings({ author, flags, contentIsHidden, toggleContent, ugcType }) {
  const existingFlags = flags?.get('flaggedTypes', Immutable.List()) || Immutable.List();

  let messageKey;
  if (existingFlags.includes(FLAG_TYPES.SPOILER)) {
    messageKey = 'spoiler_content_by_user';
  }
  if (existingFlags.includes(FLAG_TYPES.OFFENSIVE)) {
    messageKey = 'offensive_content_by_user';
  }
  if (existingFlags.includes(FLAG_TYPES.SPOILER) && existingFlags.includes(FLAG_TYPES.OFFENSIVE)) {
    messageKey = 'offensive_spoiler_content_by_user';
  }

  return (
    <div className="cp-content-warnings">
      {existingFlags.includes(FLAG_TYPES.SPOILER) && (
        <span className="content-warning">
          <Flag />
          <span className="warning-label" aria-hidden>
            <FormattedMessage id="spoiler" />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="sr_spoiler" values={{ ugcType }} />
          </ScreenReaderMessage>
        </span>
      )}
      {existingFlags.includes(FLAG_TYPES.OFFENSIVE) && (
        <span className="content-warning">
          <Flag />
          <span className="warning-label" aria-hidden>
            <FormattedMessage id="offensive" />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="sr_offensive" values={{ ugcType }} />
          </ScreenReaderMessage>
        </span>
      )}
      {(existingFlags.includes(FLAG_TYPES.STANDARDS_VIOLATION) || flags.get('flaggableTypes')?.size === 0) && (
        <span className="content-warning">
          <span className="reported-label">
            <FormattedMessage id="reported" />
          </span>
        </span>
      )}
      {existingFlags.size > 0 &&
        (contentIsHidden ? (
          <SecondaryTextButton handleClick={() => toggleContent(true)} dataKey="show-content">
            <span aria-hidden>
              <FormattedMessage id="show" />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage id={`show_${messageKey}`} values={{ username: author.get('name') }} />
            </ScreenReaderMessage>
          </SecondaryTextButton>
        ) : (
          <SecondaryTextButton handleClick={() => toggleContent(false)} dataKey="hide-content">
            <span aria-hidden>
              <FormattedMessage id="hide" />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage id={`hide_${messageKey}`} values={{ username: author.get('name') }} />
            </ScreenReaderMessage>
          </SecondaryTextButton>
        ))}
    </div>
  );
}

ContentWarnings.propTypes = {
  author: userIdentityShape.isRequired,
  flags: ImmutablePropTypes.map.isRequired,
  contentIsHidden: PropTypes.bool.isRequired,
  toggleContent: PropTypes.func.isRequired,
  ugcType: PropTypes.string.isRequired
};
